module.exports = __webpack_public_path__ + "static/img/bg-tit1.8f25429f.png";